import { action, observable } from 'mobx'

import industries  from './industries'

import Ds from './ds'

class Categories {
  @observable data = []
  @observable ds = new Ds()

  @action loadAllCategories() {
    this.ds.query(`{ categories(hash: "${ localStorage.getItem('userHash') }") { id name } }`, (data) => {
      this.data = data.categories.map((category) => {
        //category.industryName = category.industry.name
        return category
      })
    })
  }


  /* REMOVED INDUSTRIES
  @action loadAllCategories() {
    this.ds.query(`{ categories(hash: "${ localStorage.getItem('userHash') }") { id name industryId industry { id name } } }`, (data) => {
      this.data = data.categories.map((category) => {
        category.industryName = category.industry.name
        return category
      })
    })
  }
  */

  @action loadAllIndustryCategories(industryId) {
    this.ds.query(`{ categories(industryId: ${ industryId }, hash: "${ localStorage.getItem('userHash') }") { id name industry { id name } } }`, (data) => {
      this.data = data.categories.map((category) => {
        category.industryName = category.industry.name
        return category
      })
    })
  }

  @action newCategory(row) {
    const industryId = industries.findIndustryByName(row.industryName)
    this.ds.query(`mutation { addCategory(name: "${ row.name }", industryId: ${ industryId }, hash: "${ localStorage.getItem('userHash') }") { id } }`, (data) => {
      this.loadAllCategories()
    })
  }

  @action updateCategory(row) {
    //const industryId = industries.findIndustryByName(row.industryName)
    this.ds.query(`mutation { updateCategory(id: ${ row.id }, name: "${ row.name }", industryId: ${ row.industryId }, hash: "${ localStorage.getItem('userHash') }") { id } }`, (data) => {
      this.loadAllCategories()
    })
  }

  @action deleteCategory(id) {
    this.ds.query(`mutation { deleteCategory(id: ${ id }, hash: "${ localStorage.getItem('userHash') }") { id } }`, (data) => {
      this.loadAllCategories()
    })
  }
}

export default new Categories()



// WEBPACK FOOTER //
// ./src/stores/categories.js